// What the tabs of a task's panel show while they load: grey shapes where
// the content will land, so nothing jumps when it arrives.
const GHOST = 'rounded bg-gray-200';

// « Détail »: the badges, the contact card, then the description field.
export const TaskDetailSkeleton = () => (
  <div className="flex animate-pulse flex-col gap-5" aria-busy="true">
    <div className="flex gap-1.5">
      <span className={`h-6 w-20 ${GHOST}`} />
      <span className={`h-6 w-36 ${GHOST}`} />
    </div>
    <div className="flex items-center gap-3 rounded-lg border border-gray-200 p-3">
      <span className="size-10 shrink-0 rounded-full bg-gray-200" />
      <span className="flex min-w-0 flex-1 flex-col gap-2">
        <span className={`h-3.5 w-2/5 ${GHOST}`} />
        <span className={`h-3 w-3/5 ${GHOST}`} />
      </span>
      <span className="h-8 w-24 shrink-0 rounded-lg bg-gray-200" />
    </div>
    <div className="flex flex-col gap-2">
      <span className={`h-3.5 w-24 ${GHOST}`} />
      <span className="h-28 rounded-lg bg-gray-200" />
    </div>
  </div>
);

// « Activité »: the steps of the history on their line.
export const TaskActivitySkeleton = () => (
  <ol className="flex animate-pulse flex-col" aria-busy="true">
    {[64, 48, 72, 56].map((width, index, all) => (
      <li key={width} className="flex gap-3">
        <span className="flex flex-col items-center">
          <span className="size-8 shrink-0 rounded-full bg-gray-200" />
          {index < all.length - 1 && (
            <span className="w-px flex-1 bg-gray-200" />
          )}
        </span>
        <span className="flex min-w-0 flex-1 flex-col gap-2 pb-4 pt-1">
          <span className={`h-3.5 ${GHOST}`} style={{ width: `${width}%` }} />
          <span className={`h-3 w-28 ${GHOST}`} />
        </span>
      </li>
    ))}
  </ol>
);

// « Commentaires »: who and when, then the bubble.
export const TaskCommentsSkeleton = () => (
  <ol className="flex animate-pulse flex-col gap-4" aria-busy="true">
    {[70, 45, 60].map((width) => (
      <li key={width} className="flex gap-3">
        <span className="size-8 shrink-0 rounded-full bg-gray-200" />
        <span className="flex min-w-0 flex-1 flex-col gap-2">
          <span className={`h-3.5 w-40 ${GHOST}`} />
          <span
            className="h-12 rounded-lg bg-gray-200"
            style={{ width: `${width}%` }}
          />
        </span>
      </li>
    ))}
  </ol>
);
